export function isEdit(state) {
    return state.reservationProduct && state.reservationProduct.id;
}



// WEBPACK FOOTER //
// ./src/modules/modal-list-product-wms/getters.js